import React, { useId } from "react";

export const EmailIcon = (props) => {
  const uid = useId().replace(/:/g, "");
  const gradientId = `email-sent-gradient-${uid}`;

  return (
    <svg
      width="117"
      height="117"
      viewBox="0 0 117 117"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7188 38.9062H104.531C110.977 38.9062 116.25 44.1797 116.25 50.625V104.531C116.25 110.977 110.977 116.25 104.531 116.25H11.7188C5.27344 116.25 0 110.977 0 104.531V50.625C0 44.1797 5.27344 38.9062 11.7188 38.9062Z"
        fill="#DDD6FE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M112.687 112.922C110.578 114.984 107.695 116.25 104.531 116.25H11.7188C8.55469 116.25 5.67188 114.984 3.5625 112.922L58.125 61.7578L112.687 112.922Z"
        fill="#C4B5FD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7188 38.9062H104.531C107.414 38.9062 110.039 39.9609 112.078 41.6719L61.3594 75.4219C59.3437 76.7578 56.8828 76.7578 54.8672 75.4219L4.14844 41.6719C6.21094 39.9609 8.83594 38.9062 11.7188 38.9062Z"
        fill={`url(#${gradientId})`}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70.617 2.34375V33.0938H75.8904C76.8279 33.0938 77.6248 33.6094 78.0233 34.4766C78.4217 35.3203 78.2811 36.2812 77.6483 36.9844L58.992 58.4297C58.7576 58.6875 58.4529 58.8281 58.1014 58.8281C57.7498 58.8281 57.4451 58.6875 57.2108 58.4297L38.5545 36.9844C37.9451 36.2812 37.8045 35.3203 38.1795 34.4766C38.578 33.6328 39.3748 33.0938 40.3123 33.0938H45.5858V2.34375C45.5858 1.05469 46.6405 0 47.9295 0H68.2264C69.5623 0 70.617 1.05469 70.617 2.34375Z"
        fill="#22C55E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70.6172 2.34375V33.0938H75.8906C76.8281 33.0938 77.625 33.6094 78.0234 34.4766C78.4219 35.3203 78.2812 36.2812 77.6484 36.9844L58.9922 58.4297C58.7578 58.6875 58.4531 58.8281 58.1016 58.8281V0H68.25C69.5625 0 70.6172 1.05469 70.6172 2.34375Z"
        fill="#22C55E"
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="58.125"
          y1="76"
          x2="58.125"
          y2="23.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#67E8F9" />
          <stop offset="1" stopColor="#D946EF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
